<template>
  <div class="key-words">
    <div
      v-loading="loading"
      class="key-words-content"
    >
      <div class="key-words-content-header">
        <h3>商品标签</h3>
        <ds-iconfont
          class="close"
          icon-class="icon-ds-guanbi1"
          @click.native="close"
        />
      </div>
      <div class="key-words-content-con">
        <div class="tit">
          选择商品标签
        </div>
        <mk-select
          v-model="tags"
          width="460"
          placeholder="选择商品标签（多选）"
          multiple
          clearable
          filterable
        >
          <mk-option
            v-for="item in options"
            :key="item._id"
            :label="item.name"
            :value="item.name"
          >
          </mk-option>
        </mk-select>
        <div class="tips">
          若之前词条已有商品标签，设置后将会完成替换
        </div>
      </div>
      <div class="handle">
        <mk-button-biz
          width="64px"
          height="32px"
          @click="close"
        >
          取消
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          width="64px"
          height="32px"
          @click="confirm"
        >
          确认
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Array,
      default () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tags: []
    }
  },
  methods: {
    confirm () {
      this.$emit('confirm', this.tags)
    },
    close () {
      this.$emit('cancel')
    }
  }
}
</script>
<style lang="scss" scoped>
.key-words {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.32);

  .key-words-content {
    width: 500px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 4px;

    .key-words-content-header {
      width: 100%;
      height: 52px;
      box-sizing: border-box;
      border-bottom: 1px solid #e8e8e8;
      display: flex;
      align-items: center;
      justify-content: space-between;

      h3 {
        font-size: 14px;
        color: #262626;
        margin-left: 20px;
      }

      .close {
        font-size: 14px;
        color: #bfbfbf;
        margin-right: 20px;
        cursor: pointer;
      }
    }

    .key-words-content-con {
      width: calc(100% - 40px);
      margin: 0 auto;

      .tit {
        font-size: 13px;
        line-height: 20px;
        color: #262626;
        font-weight: 400;
        margin: 20px 0 8px 0;
      }

      .tips {
        font-size: 12px;
        font-weight: 400;
        color: #888;
        line-height: 16px;
        margin: 8px 0 32px 0;
      }
    }

    .handle {
      display: flex;
      justify-content: flex-end;
      margin: 0 15px 15px 0;

      /deep/ .el-button {
        font-size: 13px;
      }
    }
  }
}
</style>
